import { styled, Box } from "@mui/material";
import { getSegmentBackgroundColor } from "../../utils/contentBlocksEditorUtils";

export const EditorContainer = styled(Box)(({ segmentColor }) => ({
  width: "375px",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "flex-start",
  marginTop: "20px",
  marginBottom: "20px",
  border: "1px solid #e1e1e1",
  gap: "10px",
  border: `1px solid ${segmentColor}`,
  backgroundColor: getSegmentBackgroundColor(segmentColor),
}));

export const EditorLeftBorder = styled(Box)(({ segmentColor }) => ({
  borderRadius: "10px 0px 0px 10px",
  backgroundColor: segmentColor,
  width: "11px",
}));

export const EditorRightContainer = styled(Box)({
  width: "465px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "7px 0px 7px 0px",
});
